/* tslint:disable */
/* eslint-disable */
/**
 * channels-com
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface MinBalanceResponse
 */
export interface MinBalanceResponse {
  /**
   *
   * @type {string}
   * @memberof MinBalanceResponse
   */
  message: string;
}

export function MinBalanceResponseFromJSON(json: any): MinBalanceResponse {
  return MinBalanceResponseFromJSONTyped(json, false);
}

export function MinBalanceResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MinBalanceResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    message: json['message'],
  };
}

export function MinBalanceResponseToJSON(
  value?: MinBalanceResponse | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    message: value.message,
  };
}
